// 公開おしらせページ（ログイン不要）。
// 一斉配信のSMS/メール/LINEに載せるURL（/notice/:token）から、休業案内などを
// ログインせずにパッと確認できるようにする。トークン一致した配信内容のみ表示（個人情報なし）。
import { useState, useEffect } from "react";
import { LinkifyText } from '../compornents/LinkifyText';
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Gtag } from '../compornents/Analytics';

export function Notice() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const domain = process.env.REACT_APP_IS_DEV !== 'true'
        ? 'https://api.laundrypack.app'
        : 'https://laundrypack-now-api-dev.laundrypack.workers.dev';
      try {
        const res = await axios.get(`${domain}/api/notice/${token}`);
        if (res.data && res.data.result === 1) {
          setNotice(res.data.notice);
          // お知らせ表示の計測（公開ページ・ログイン不要。token で記事を識別）
          Gtag('view_notice', { kind: 'public', token, title: String(res.data.notice?.title || '').slice(0, 60) });
        }
        else setError(true);
      } catch {
        setError(true);
      }
      setLoading(false);
    }
    load();
  }, [token]);

  return (
    <div className="App">
      <div className="Notification">
        <div className="toolbar">
          <div className="toolbar_left"></div>
          <div className="toolbar_center">お知らせ</div>
          <div className="toolbar_right"></div>
        </div>
        <div className="mt-3 mb-5" style={{ padding: '0 16px' }}>
          {loading && <div className="mt-4">読み込み中…</div>}
          {!loading && error && (
            <div className="mt-4">
              お知らせが見つかりませんでした。
              <div className="mt-4">
                <button className="btn btn-oval btn-yellow form-control" onClick={() => navigate('/')}>アプリを開く</button>
              </div>
            </div>
          )}
          {!loading && notice && (
            <div className="order_body mb-3">
              <div className="order_header mb-2">
                <div className="order_date">{String(notice.created_at || '').slice(0, 16)}</div>
              </div>
              <div className="h4 mb-2">{notice.title}</div>
              <div className="content mb-4 mt-4" style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
                <LinkifyText text={notice.matter} />
              </div>
              {notice.img ? (
                <div className="content mb-4 mt-4">
                  <img src={notice.img} className="ItemImage" alt="お知らせ画像" style={{ maxWidth: '100%' }} />
                </div>
              ) : null}
              <div className="mt-5 pt-3 border-top">
                <button className="btn btn-oval btn-yellow form-control" onClick={() => navigate('/')}>アプリを開く</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
